/**
 * Created by shubham on 19/9/18.
 */

import { NgModule} from '@angular/core';
import { Http} from '@angular/http';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ApplicationManagementRoutingModule } from './applicationManagement-routing.module';
import { ApplicationManagementComponent } from './applicationManagement.component';
import { AddApplicationComponent } from './addApplication/addApplication.component';
import { ApplicationListComponent } from "./applicationList/applicationList.component";
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { ActivateDeactivateModule } from "../../activate-deactivate-request/activate-deactivate-request.module";
import { APPCONFIG } from '../../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        NgxDatatableModule,
        ReactiveFormsModule,
        AngularMultiSelectModule,
        ActivateDeactivateModule,
        ApplicationManagementRoutingModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+'/_ah/api/noAuthApi/v1/i18nJson', ''),
            deps: [Http]
        })
    ],
    declarations: [
        ApplicationManagementComponent,
        AddApplicationComponent,
        ApplicationListComponent
    ],
    exports: [
    ]
})

export class ApplicationManagementModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationManagement.module.ts